// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-CVweYr","listbox":"listbox-z916Jr","option":"option-iHmerL","optionHighlighted":"optionHighlighted-OnGPgf"};